const Privacy_policy = {
privacy_pol:"Images/Privacy/privacy_pol.png"
}
export default Privacy_policy